import { Category, Post, Work } from 'generated-graphql';
import Link from 'next/link';
import {
  FifthTitle,
  Author,
  ThirdParagraph,
  Truncated,
  Img,
  FourthParagraph,
  TimeRead,
  FifthParagraph,
  Categories,
  Excerpt,
} from '@/componentsWP/StyledComponentsLib/StyledComponentsLib';
import styled from 'styled-components';
import { url } from 'inspector';
import get from 'lodash/get';
import dayjs from 'dayjs';
import clip from 'text-clipper';
import Image from 'next/image';
import getResourceItemUrl from '@/helpers/resourceItemUrl';


const FullWidthWrapper = styled.div`
margin: 20px 0;
    h5 {
      display:contents;
    }
img {
  border-radius: 16px;
}
.flip {
  order: 1;
}
`;
const BackgroundImage = styled.div`
  background-size:cover;
  background-repeat: no-repeat;
  height:100%;
  min-height:302px;
  background-position: center center;
  border-radius: 16px;

  @media all and (min-width: 1200px) {
  min-height:380px; 
  }
`;
interface ResourceItemFullWidthProps {
  flip?: string;
  item: Post | Work;
}

const ResourceItemFullWidth: React.FC<ResourceItemFullWidthProps> = ({
  item,
  flip
}) => {
  const publisherData = get(item, 'publishers.nodes.0', {});
  const publisher = {
    name: get(publisherData, 'name', ''),
    image: get(
      publisherData,
      'people.profilePicture.mediaDetails.sizes.0.sourceUrl',
      '',
    ),
    position: get(publisherData, 'people.position', ''),
    bio: get(publisherData, 'people.bio', ''),
    slug: get(publisherData, 'slug', ''),
  };

  const { url, contentType, target } = getResourceItemUrl(item);


  const Item = (
    <FullWidthWrapper className='row'>
      <div className={`col-12 col-xl-8 px-0 ${flip}`}>
        <Image width={896} height={480} src={item.featuredImage?.node.sourceUrl || ''} className='img-fluid' alt={item.title || 'Latest resource image'} loading="eager" quality={100} />
      </div>
      <div className="col-12 col-xl-4 px-xl-3 px-0">
        <div className='ps-xl-2 pt-4 pt-xl-0'>
          {item.__typename === "Work" && <FourthParagraph className='mb-2'>{item.works?.client}</FourthParagraph>}

          <div className='d-flex justify-content-between aligin-items-top pb-3'>
            <FifthTitle className="pt-5 ">
              {item.title}
            </FifthTitle>
          </div>


          {item.__typename === "Post" && <Author>
            {publisher.image && <div className='me-3'><img src={publisher.image} alt={publisher.name} /></div>}
            <div>
              {publisher.name && <FourthParagraph className='m-0' TypeWight="SemiBold">{publisher.name}</FourthParagraph>}
              <FourthParagraph className='m-0' TypeWight="Thin"> {dayjs(item.date).format('MMMM DD, YYYY')}</FourthParagraph>
            </div>
          </Author>
          }
          {item.categories?.nodes.length ? (
            <div className="mt-4">
              {item.categories.nodes.map(
                (c: Category) =>
                  (c.parent?.node || c.name === "Featured") && c?.color?.backgroundColor && (
                    <Categories
                      color={c?.color?.color || ''}
                      bgColor={c?.color?.backgroundColor || ''}
                      key={c.id}
                    >
                      {c.name}
                    </Categories>
                  ),
              )}
            </div>
          ) : null}
        </div>
      </div>
    </FullWidthWrapper>
  )

  return (
    <a style={{ color: '#000', textDecoration: "none" }} href={url} target={target}>
      {Item}
    </a>
  );
};

export default ResourceItemFullWidth;
